import React from 'react';
import ToolbarFullpageContainer from 'components/app_common/ToolbarFullpageContainer';
import { Box, Paper } from '@material-ui/core';
import useStyles from './styles';
import Chatgroups from './components/Chatgroups';
import Conversation from './components/Conversation';
import ChatFloating, { ChatFloatingPure } from './components/ChatFloating';
import ChatsNotFound from './components/ChatsNotFound';
import Profile from './components/Profile';
import MessageNotification from './components/MessageNotification';
import ChatNotifications from './components/ChatNotifications';
import './index.css';

interface IChatProps {
  chatgroups?: React.ReactElement;
  conversation?: React.ReactElement;
  profile?: React.ReactElement;
}

const ChatPageContainer = ({
  chatgroups,
  conversation,
  profile,
}: IChatProps) => {
  const classes = useStyles();

  return (
    <>
      <ToolbarFullpageContainer>
        <Box className={classes.chatContainer}>
          {chatgroups && (
            <Box className={classes.contactsContainer}>{chatgroups}</Box>
          )}
          {conversation && (
            <Box className={classes.conversationContainer}>{conversation}</Box>
          )}
          {profile && <Box className={classes.profileContainer}>{profile}</Box>}
        </Box>
      </ToolbarFullpageContainer>
    </>
  );
};

export {
  Chatgroups,
  Conversation,
  Profile,
  ChatPageContainer,
  ChatFloating,
  ChatFloatingPure,
  ChatsNotFound,
  MessageNotification,
  ChatNotifications,
};
